import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TProductsRequestBody, TProductsResponse } from 'shared/types/TRankingService';

export const fetchOffersDataApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getOffers: build.mutation<TProductsResponse, TProductsRequestBody>({
      query: (body) => ({
        url: BFF_API_ROUTES.getOffersAndGroups,
        method: 'POST',
        body,
      }),
    }),
  }),
});
